import RenderIf from "common/components/RenderIf";
import Skeleton from "common/components/ui/Skeleton";

interface PriceProps {
  priceValue: string;
  priceSubtext: string;
  isLoading: boolean;
}

export default function Price({
  priceValue,
  priceSubtext,
  isLoading,
}: PriceProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:gap-x-0.5 items-end">
      {isLoading ? (
        <Skeleton className="h-[52px] w-24 lg:h-7 lg:w-20" />
      ) : (
        <>
          <span className="text-2xl-bold lg:text-lg-bold">{priceValue}</span>
          <RenderIf condition={!!priceSubtext}>
            <span className="text-sm-medium lg:text-button-xs text-black-500 lg:mb-[3px]">
              / {priceSubtext}
            </span>
          </RenderIf>
        </>
      )}
    </div>
  );
}
